import tag from "../api/tag";

export default {
  getTags({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await tag.getTags(payload);

        commit("SET_TAGS", data.data.tagRecord);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  addTag({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await tag.addTag(payload);

        commit("ADD_TAG", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteTag({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await tag.deleteTag(payload);

        commit("DELETE_TAG", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editTag({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await tag.editTag(payload);
        commit("EDIT_TAG", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
